import React, { useState } from 'react';
import { FiPhone, FiMail, FiMapPin, FiCopy, FiCheck } from 'react-icons/fi';
import ProjectRequestForm from './ProjectRequestForm';

const Contact = () => {
    const [copiedPhone, setCopiedPhone] = useState(false);
    const [copiedEmail, setCopiedEmail] = useState(false);

    const handleCopyPhone = () => {
        navigator.clipboard.writeText('7276088386');
        setCopiedPhone(true);
        setTimeout(() => setCopiedPhone(false), 2000);
    };

    const handleCopyEmail = () => {
        navigator.clipboard.writeText('hello@bercastle.com');
        setCopiedEmail(true);
        setTimeout(() => setCopiedEmail(false), 2000);
    };

    return (
        <div className='relative py-20 md:py-32 overflow-hidden' id="contact">

            <div className='container-custom relative z-10'>
                {/* Two column layout */}
                <div className='grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-start'>
                    {/* Left column - Title and Contact information */}
                    <div>
                        {/* Title section */}
                        <div className='mb-12 md:mb-16'>
                            <h2 className='text-4xl md:text-6xl font-bold text-slate-900 mb-6'>Let's Build Something Amazing</h2>
                        </div>

                        {/* Contact information */}
                        <div className='space-y-12'>
                            {/* Phone */}
                            <div className='flex items-start gap-8'>
                                <div className='flex-shrink-0'>
                                    <FiPhone className='w-10 h-10 text-black' />
                                </div>
                                <div className='group flex-1'>
                                    <h3 className='text-2xl font-bold text-slate-800 mb-2'>Call Us</h3>
                                    <div className='flex items-center gap-3'>
                                        <a href="tel:7276088386" className='text-primary font-medium text-lg underline-offset-2 group-hover:underline'>(727) 608-8386</a>
                                        <button
                                            onClick={handleCopyPhone}
                                            className='p-2 hover:bg-gray-200 rounded-lg transition-colors'
                                            title="Copy phone number"
                                        >
                                            {copiedPhone ? (
                                                <FiCheck className='w-5 h-5 text-green-600' />
                                            ) : (
                                                <FiCopy className='w-5 h-5 text-gray-600 hover:text-black' />
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Email */}
                            <div className='flex items-start gap-8'>
                                <div className='flex-shrink-0'>
                                    <FiMail className='w-10 h-10 text-black' />
                                </div>
                                <div className='group flex-1'>
                                    <h3 className='text-2xl font-bold text-slate-800 mb-2'>Email Us</h3>
                                    <div className='flex items-center gap-3'>
                                        <a href="mailto:hello@bercastle.com" className='text-primary font-medium text-lg underline-offset-2 group-hover:underline'>hello@bercastle.com</a>
                                        <button
                                            onClick={handleCopyEmail}
                                            className='p-2 hover:bg-gray-200 rounded-lg transition-colors'
                                            title="Copy email address"
                                        >
                                            {copiedEmail ? (
                                                <FiCheck className='w-5 h-5 text-green-600' />
                                            ) : (
                                                <FiCopy className='w-5 h-5 text-gray-600 hover:text-black' />
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Location */}
                            <div className='flex items-start gap-8'>
                                <div className='flex-shrink-0'>
                                    <FiMapPin className='w-10 h-10 text-black' />
                                </div>
                                <div>
                                    <h3 className='text-2xl font-bold text-slate-800 mb-2'>Visit Us</h3>
                                    <p className='text-slate-600 text-lg'>
                                        200 Central Ave, 4th Floor<br />
                                        Saint Petersburg, FL 33701
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right column - Project Request Form */}
                    <div>
                        <ProjectRequestForm />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;